import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import axios from "axios";
import { useDispatch } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";

function OPT_Confirm() {
  let user = sessionStorage.getItem("user");
  user = JSON.parse(user);

  const [password, setPassword] = useState("");
  const [otp, setOTP] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // console.log("password",password);
  const referral_OTP = async () => {
    try {
      let responceRight = await API?.post(
        "/AdminLogin_2",
        {
          userid: user.username,
          password: user.password,
          otp: otp,
          ipaddress: "12345.12",
          secretkey: "6545",
        },
        {}
      );
      console.log("My_Team", responceRight?.data);
      if (responceRight.data?.data?.result == "Successfull") {
        swal({
          title: "Success..!",
          text: "Your Login has been successfull!!",
          icon: "success",
          button: "OK",
        }).then((okay) => {
          if (okay) {
            sessionStorage.setItem(
              "user",
              JSON.stringify({
                uid: user.username,
              })
            );
            
            
            // window.location.href = "./Dashboard";
            dispatch(
              updateAuth({
                AdminAuth: responceRight.data.success,
                userId: responceRight.data.data.uid,
                username: user.username,
                jwt_token: responceRight.data.token,
              })
            );

            navigate("/Dashboard");
          }
        });
      } else {
        swal({
          title: "Login Error..!!",
          text: "Invalid OTP",
          icon: "error",
          button: "OK",
        });
      }
    } catch (e) {
      {
        e?.response &&
          e?.response.status === 400 &&
          swal({
            title: "Login Error..!!",
            text: e?.response?.data?.data,
            icon: "error",
            button: "OK",
          });
      }
      console.log("Error While calling Myteam API", e);
    }
  };

  return (
    <div>
      <form id="Form1">
        <div class="wrapper-page2">
          <div class="wrapper-page mtip_up">
            <center>
              <img
                src="/assets/images/logo.png"
                style={{ width: "150px", paddingTop: "30px" }}
              />
              <br />
              <br />
            </center>
            <div
              class="panel panel-color panel-primary panel-pages"
              style={{
                border: "1px solid rgb(0 0 0 / 76%)",
                boxShadow: "0px 2px 6px 4px #00000078",
              }}
            >
              <p class="heddlogin">Confirm OTP</p>
              <div id="Panel1" ng-show="panel1">
                <div class="panel-body">
                  <div class="form-horizontal m-t-20">
                    <div class="form-group">
                      <div class="col-xs-12">
                        <input
                          type="text"
                          class="form-control input-lg"
                          onChange={(e) => setOTP(e.target.value)}
                          placeholder="Enter OTP"
                          maxLength={20}
                        />
                      </div>
                    </div>
                    {/* <div class="form-group">
                      <div class="col-xs-12">
                        <input
                          type="password"
                          class="form-control input-lg"
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder="Enter Pin Number"
                        />
                      </div>
                    </div> */}
                    <div class="form-group text-center m-t-40">
                      <div class="col-xs-12">
                        <a
                          //   href=""
                          type="button"
                          class="btn btn-primary btn-lg w-lg"
                          onClick={() => referral_OTP()}
                        >
                          Sign IN
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default OPT_Confirm;
